import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigation_geo_toggle_close } from '../../../redux/reducers/navigationSlice';
import NavGeography from './NavGeography';

import {
   GeoMetaPicker,
   GeoMetaPickerClose,
   GeoMetaPickerWrapper,
   GeoMetaPickerContainer,
   GeoMetaPickerCountriesCountry,
   GeoMetaPickerRegion,
   GeoMetaPickerCountries
} from './NavGeographies.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLOR } from '../../../theme/constants';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

function mapStateToProps(state, ownProps) {
   return {
      GeosOpen: state.navigation.geosOpen,
      Geographies: state.navigation.geographies
   };
}

const mapDispatchToProps = (dispatch, ownProps) => {
   return {
      navGeoToggleClose: () => {
         dispatch(navigation_geo_toggle_close());
      }
   };
};

class NavGeographies extends Component<
   {
      GeosOpen: boolean;
      navGeoToggleClose: any;
      Geographies: any[];
   },
   {}
> {
   constructor(props) {
      super(props);
   }

   public render() {
      const { GeosOpen, navGeoToggleClose, Geographies } = this.props;

      const geographiesStackArr = Geographies.slice(0, 3);
      const geographiesNormalArr = Geographies.slice(3);

      const regionList = regions => {
         const list = regions.map((region, index) => (
            <GeoMetaPickerCountriesCountry key={index}>
               <NavGeography name={region.Name} id={region.GeoId} />
            </GeoMetaPickerCountriesCountry>
         ));
         return list;
      };

      const geographyStackedList = geographiesStackArr.map((geography, index) => (
         <GeoMetaPickerContainer key={index} className='stack'>
            <GeoMetaPickerRegion>
               <NavGeography name={geography.Name} id={geography.GeoId} />
            </GeoMetaPickerRegion>
            <GeoMetaPickerCountries>{regionList(geography.Regions)}</GeoMetaPickerCountries>
         </GeoMetaPickerContainer>
      ));

      const geographyList = geographiesNormalArr.map((geography, index) => (
         <GeoMetaPickerContainer key={index}>
            <GeoMetaPickerRegion>
               <NavGeography name={geography.Name} id={geography.GeoId} />
            </GeoMetaPickerRegion>
            <GeoMetaPickerCountries>{regionList(geography.Regions)}</GeoMetaPickerCountries>
         </GeoMetaPickerContainer>
      ));

      const geographiesContainerStyles = () => {
         const isActive = GeosOpen ? 'active' : '';
         return `${isActive}`;
      };

      return (
         <GeoMetaPicker className={geographiesContainerStyles()}>
            <GeoMetaPickerClose
               data-analytics='Forecasts-Navigation-Geographies-Close'
               id='Forecasts-Navigation-Geographies-Close'
               onClick={() => navGeoToggleClose()}
            >
               <FontAwesomeIcon color={COLOR.BLUE} icon={faTimes} width={14} />
            </GeoMetaPickerClose>
            <GeoMetaPickerWrapper>
               <GeoMetaPickerContainer>{geographyStackedList}</GeoMetaPickerContainer>
               {geographyList}
            </GeoMetaPickerWrapper>
         </GeoMetaPicker>
      );
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavGeographies);
